import { format } from 'date-fns';

export const formatFromSecondToMinutes = (seconds: number): string => {
  if (!seconds || seconds <= 0) return '0 min';

  // Se meno di 1 minuto, mostra i secondi
  if (seconds < 60) {
    return `${seconds} sec`;
  }

  // Calcola i minuti precisi (con decimali)
  const minutes = seconds / 60;

  // Formatta senza decimali se il numero è intero, altrimenti con 1 decimale
  const mins = Math.floor(minutes);
  const secs = Math.round(seconds % 60);
  if (mins === 0) {
    return `${secs} sec`;
  }
  if (secs === 0) {
    return `${mins} min`;
  }
  return `${mins} min ${secs} sec`;
};

export const formatDurationRounded = (seconds: number): string => {
  const roundedSeconds = Math.round(seconds / 60) * 60;
  return formatFromSecondToMinutes(roundedSeconds);
};

export function formatTimestampToTime(
  timestamp: string | number | Date
): string {
  return format(new Date(timestamp), 'HH:mm:ss');
}

export function formatTimestampToTimeWithMs(
  timestamp: string | number | Date
): string {
  return format(new Date(timestamp), 'HH:mm:ss.SSS');
}

export function formatTimestampToDateTimeWithMs(
  timestamp: string | number | Date
): string {
  return format(new Date(timestamp), 'dd/MM/yyyy, HH:mm:ss.SSS');
}

export function formatTimestampToMinutesSeconds(
  timestamp: string | number | Date
): string {
  return format(new Date(timestamp), 'mm:ss');
}

export function formatElapsedTimeFromStart(
  eventTimestamp: number,
  sessionStartTimestamp: number | null
): string {
  if (!sessionStartTimestamp) {
    // Fallback to timestamp format if no session start
    return formatTimestampToMinutesSeconds(eventTimestamp);
  }

  const elapsedSeconds = Math.floor(
    (eventTimestamp - sessionStartTimestamp) / 1000
  );

  // Handle negative elapsed time (event before session start)
  if (elapsedSeconds < 0) {
    return '00:00';
  }

  const minutes = Math.floor(elapsedSeconds / 60);
  const seconds = elapsedSeconds % 60;

  return `${minutes.toString().padStart(2, '0')}:${seconds
    .toString()
    .padStart(2, '0')}`;
}
